import React from "react";
import { Link } from "react-router-dom";
import { Phone, Smartphone, Mail, MapPin, Globe, Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { WhatsAppIcon } from "./icons";
import { COMPANY } from "../data/site";

export const Footer = () => {
  return (
    <footer className="bg-brand-darkBlue text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="bg-white rounded-2xl p-4 inline-block">
            <Logo />
          </div>
          <p className="mt-5 text-brand-red font-semibold text-lg font-heading">
            {COMPANY.tagline}
          </p>
          <p className="mt-3 text-white/70 leading-relaxed">
            Providing exceptional, trustworthy in-home healthcare staffing solutions across the
            United States.
          </p>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold text-lg mb-4">Explore</h4>
          <ul className="space-y-3 text-white/80">
            <li><Link to="/" data-testid="footer-link-home" className="hover:text-brand-red">Home</Link></li>
            <li><Link to="/services" data-testid="footer-link-services" className="hover:text-brand-red">Services</Link></li>
            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-brand-red">About Us</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-brand-red">Contact</Link></li>
            <li><Link to="/contact#apply" data-testid="footer-link-careers" className="hover:text-brand-red">Careers — Apply Here</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold text-lg mb-4">Get In Touch</h4>
          <ul className="space-y-3 text-white/80">
            <li className="flex items-center gap-3"><Phone className="w-5 h-5 text-brand-red" /> {COMPANY.phone}</li>
            <li className="flex items-center gap-3"><Smartphone className="w-5 h-5 text-brand-red" /> {COMPANY.mobile}</li>
            <li>
              <a href={`https://wa.me/${COMPANY.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 hover:text-brand-red transition-colors">
                <WhatsAppIcon className="w-5 h-5 text-brand-red" /> WhatsApp
              </a>
            </li>
            <li className="flex items-center gap-3"><Mail className="w-5 h-5 text-brand-red" /> {COMPANY.email}</li>
            <li>
              <a href={COMPANY.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 hover:text-brand-red transition-colors">
                <Instagram className="w-5 h-5 text-brand-red" /> @{COMPANY.instagram}
              </a>
            </li>
            <li className="flex items-center gap-3"><Globe className="w-5 h-5 text-brand-red" /> {COMPANY.website}</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold text-lg mb-4">Hours of Operation</h4>
          <ul className="space-y-2 text-white/80">
            {COMPANY.hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-4">
                <span>{h.day}</span>
                <span className="text-white/60">{h.time}</span>
              </li>
            ))}
          </ul>
          <div className="mt-5 flex items-start gap-3 text-white/80">
            <MapPin className="w-5 h-5 text-brand-red mt-1 shrink-0" />
            <span>
              {COMPANY.address.city}<br />
              {COMPANY.address.state}<br />
              {COMPANY.address.country}
            </span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 text-white/60 text-sm">
          © {new Date().getFullYear()} {COMPANY.nameUpper}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
